import { z } from "zod";

const PhoneNumberInventorySchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    
    phoneNumber: z.string().describe("The E.164 phone number."),
    provider: z.string().describe("The provider (e.g., 'twilio', 'signalwire')."),
    
    status: z.enum(['available', 'assigned', 'cooldown']).default('available'),
    
    // Assignment details
    subscriptionId: z.string().optional().nullable().describe("The tenant currently holding this number."),
    serviceCode: z.string().optional().nullable(),
    assignedAt: z.coerce.date().optional().nullable(),

    // Capabilities & Metadata
    capabilities: z.array(z.string()).default(['voice', 'sms']),
    countryCode: z.string().length(2).default('US'),
    region: z.string().optional().nullable(),
    
    // Cost tracking (Base cost from provider, not including markup)
    providerMetadata: z.record(z.any()).optional().default({}),
    costs: z.object({
        monthly: z.number().default(0),
        currency: z.string().default('USD')
    }).optional(),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default PhoneNumberInventorySchema;